import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';

export function pharmacyIdsValidator(control: AbstractControl): AsyncValidatorFn {
  return (): Observable<ValidationErrors | null> => {
    if (control.value.length > 0) {
      const values: string[] = [];
      control.value.split(',').forEach((el: string) => {
        values.push(el.replace(' ', ''));
        if (el.includes('.')) {
          values.push(el);
        }
      });
      let incorrectCode = '';
      for (const element of values) {
        if (element && element.length !== 0 && (element.length > 7 || !Number(element))) {
          incorrectCode = element;
          break;
        }
      }
      if (incorrectCode.length > 0) {
        return of({ pharmacyIds: incorrectCode });
      } else {
        return of(null);
      }
    }
    return of(null);
  };
}

